import { ref, computed, watchEffect } from "vue";
import { watchImmediate } from "@vueuse/core";

export function useKeypadReferenceOptions(props, showingPopover) {
  let referenceSelectorTag = computed(() => {
    if (props.referenceSelector)
      return props.tag.$session.system.$atPath(props.referenceSelector);
    else 
      return null;
  });
  
  let cellReferenceCode = computed(() => {
    return referenceSelectorTag.value?.value;
  });
  
  let cellReferenceOption = computed(() => {
    return props.referenceOptions?.find(option => option.value == cellReferenceCode.value);
  });
  
  let cellPrefix = computed(() => {
    return cellReferenceOption.value?.prefix;
  });
  
  let cellReference = computed(() => {
    return cellReferenceOption.value?.reference;
  });
  
  let popoverReferenceCode = ref(referenceSelectorTag.value?.value);
  watchEffect(() => {
    if (showingPopover.value)
      popoverReferenceCode.value = referenceSelectorTag.value?.value;
  });

  let popoverReferenceOption = computed(() => {
    return props.referenceOptions?.find(option => option.value == popoverReferenceCode.value);
  });
  
  let popoverPrefix = computed(() => {
    return popoverReferenceOption.value?.prefix || null;
  });
  
  let popoverReference = computed(() => {
    return popoverReferenceOption.value?.reference || null;
  });
  
  function getSubmitPopoverReferenceTag(cell, tag) {
    let system = tag.$session.system;
    let reference = cell.componentArgs.referenceOptions?.find(option => option.value == popoverReferenceCode.value).reference;
    let referenceTag = reference ? system.$atPath(reference) : null;
    return referenceTag;
  }
  
  function getSubmitValues(cell, value) {
    // Get the tag and referenceSelector associated with the cell.
    let tag = cell.componentArgs.tag;
    let system = tag.$session.system;
    let referenceSelector = (tag == props.tag) ? props.referenceSelector : cell.componentArgs.referenceSelector;
    if (referenceSelector == null) {
      return [
        { handle: tag.handle, value }
      ];
    }
    else {
      let referenceSelectorTag = system.$atPath(referenceSelector);
      return [
        { handle: tag.handle, value },
        { handle: referenceSelectorTag.handle, value: popoverReferenceCode.value }
      ];
    }
  }

  return {
    referenceSelectorTag,
    cellReferenceCode,
    cellReferenceOption,
    cellPrefix,
    cellReference,
    popoverReferenceCode,
    popoverReferenceOption,
    popoverPrefix,
    popoverReference,
    getSubmitPopoverReferenceTag,
    getSubmitValues
  };
}

